import React from 'react';
import { required, SimpleForm, TextInput, NumberInput } from 'react-admin';
import { nonNegativeInt } from 'utils/validation';
import { TinyMCEEditor } from 'Components';

const TemplateForm = (props) => {
  return (
    <SimpleForm {...props}>
      <TextInput
        source="name"
        validate={required()}
      />
      <TextInput source="template" validate={required()} multiline />
      {/* <TinyMCEEditor source="content"/>  */}
    </SimpleForm>
  );
};

export default TemplateForm;
